var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('date-picker',_vm._b({attrs:{"value":_vm.value,"lang":_vm.lang,"format":_vm.format},on:{"input":function($event){return _vm.$emit('input', $event)}}},'date-picker',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }